import { useSelector } from 'react-redux';
import { useStoredValue } from 'shared/utils/hooks/useStoredValue';
import { IStore } from 'store/configureStore';

export function useStoredSelector<T>(selector: (store: IStore) => T): T {
    const storeValue = useSelector(selector);
    return useStoredValue(storeValue);
}
